import { render, staticRenderFns } from "./ButtonConfigTable.vue?vue&type=template&id=224c2037&scoped=true"
import script from "./ButtonConfigTable.vue?vue&type=script&lang=js"
export * from "./ButtonConfigTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224c2037",
  null
  
)

export default component.exports